import { ECountries } from '@/_types';

export const HEADER_DESKTOP_HEIGHT = 80;
export const BLOCK_WITH_SELECTORS_HEIGHT_MOBILE = 44;
export const MENU_HEIGHT_MOBILE = 76;
export const TOP_SCROLL_TOLERANCE = 1;
export const BREACKPOINT_DESKTOP_MIN = 1024;
export const AZ_COUNTRY_CODE = 'az';

export const DOMAIN_ZONE_BY_COUNTRY: Partial<Record<ECountries, string>> = {
  [ECountries.RU]: 'ru',
  [ECountries.EN]: 'ru',
  [ECountries.BY]: 'by',
  [ECountries.ZH]: 'cn',
  [ECountries.CN]: 'cn',
  [ECountries.GE]: 'ge',
  [ECountries.KZ]: 'ru',
  [ECountries.TJ]: 'tj',
};

export const WB_STAGE_COUNTRIES = new Set([
  ECountries.RU,
  ECountries.EN,
  ECountries.BY,
  ECountries.ZH,
  ECountries.CN,
  ECountries.KZ,
]);
